export default "/images/vendor/flag-icons/flags/4x3/nf.svg?96d57c56bd4feba75b0ec87da9e0e133";